import { Component } from '@theme/component';
import { QuantitySelectorUpdateEvent } from '@theme/events';

/**
 * A compact quantity control for cart lines rendered as a native <select>.
 *
 * It mirrors the event contract of the +/- quantity selector: on change it
 * broadcasts a QuantitySelectorUpdateEvent that the parent cart-items-component
 * listens for and turns into a cart change request.
 *
 * @typedef {Object} Refs
 * @property {HTMLSelectElement} quantityDropdown
 *
 * @extends {Component<Refs>}
 */
class CartQuantityDropdownComponent extends Component {
  requiredRefs = ['quantityDropdown'];

  /**
   * Handles the dropdown selection change and broadcasts a quantity update.
   * @param {Event} event - The change event.
   */
  onSelectQuantity(event) {
    const select = this.refs.quantityDropdown;
    if (!(select instanceof HTMLSelectElement)) return;

    const quantity = parseInt(select.value, 10);
    if (Number.isNaN(quantity)) return;

    const cartLine = Number(select.dataset.cartLine) || undefined;

    this.dispatchEvent(new QuantitySelectorUpdateEvent(quantity, cartLine));
  }
}

if (!customElements.get('cart-quantity-dropdown-component')) {
  customElements.define('cart-quantity-dropdown-component', CartQuantityDropdownComponent);
}
